import store from './../store/index.js'
import axios from 'axios'
const baseURL = process.env.NODE_ENV === 'production' ? 'https://customer.medsci.cn' : '/api';

// 请求拦截器
let requestTime = 0;
axios.interceptors.request.use(function(config) {
    requestTime = 0;
    setTimeout(function() {
        if (requestTime > 1500) {
            // 判断ajax请求时间
            store.dispatch('showLoading');
        }
    }, 1500);
    return config;
})
// 响应拦截器
axios.interceptors.response.use(function(response) {
    requestTime = 1500;
    store.dispatch('closeLoading');
    return response;
})
export function apiAxios(method, url, params) {
    let httpDefault = {
        method: method,
        baseURL: baseURL,
        url: url,
        // `params` 是即将与请求一起发送的 URL 参数
        // `data` 是作为请求主体被发送的数据
        params: method === 'GET' || method === 'DELETE' ? params : null,
        data: method === 'POST' || method === 'PUT' ? params : null,
        timeout: 10000,
        headers: {
            token: "85bb9c61cc363a76be37970064f5e725"
        }
    }
    // 注意**Promise**使用(Promise首字母大写)
    return new Promise((resolve, reject) => {
        axios(httpDefault)
            // 此处的.then属于axios
            .then((res) => {
                resolve(res)
            }).catch((response) => {
                // errorState(response)
                reject(response)
            })
    })
}

export default {
    // 获取资讯列表数据
    newsListApi() {
        let params = {
            module: store.state.newType,
            category: store.state.newCategory
        };
        return apiAxios('GET', '/customer/questions', params)
    },
    allListApi() {
        return apiAxios('GET', '/customer/news-list', {})
    },
    newApi() {
        let newId = store.state.newId;
        return apiAxios('GET', '/customer/questions/' + newId)
    }
}
